import React, {useContext, useEffect, useRef, useState} from "react";
import {ThemeContext} from "../../../../../providers/themeContext/theme-context.tsx";
import {useUserContext} from "../../../../../providers/userProvider/user-context.tsx";
import CustomPopup from "../../../../../components/CustomPopup";
import {IVSPlayerRoomInfo} from "../../../../../common/utils/http/IResponse.ts";
import '../index.css'
import {formatTime} from "../../../../../common/utils/date-format.ts";
import {GAEvents} from "../../../../../common/utils/GA4/GAEvents.ts";
import Avatar from "../../../../../components/Avatar/Avatar.tsx";

type Props = {
    roomResult?: IVSPlayerRoomInfo;
    isOpen: boolean;
    onClose: () => void;
};

type vsPlayer = {
    name?: string,
    avatar?: string,
    steps?: number,
    time?: number,
    win?: boolean,
    result?: boolean,
}

// daily 游戏失败时的弹窗
const VsPlayerGameEndDialog: React.FC<Props> = ({
                                                    isOpen,
                                                    onClose,
                                                    roomResult
                                                }) => {

    // 主题全局管理器
    const {imgUrls} = useContext(ThemeContext);
    // 全局用户信息provider
    const {user} = useUserContext();
    const targetRef = useRef(null)
    // 左边 player
    const [leftPlayer, setLeftPlayer] = useState<vsPlayer>({});
    // 右边 player
    const [rightPlayer, setRightPlayer] = useState<vsPlayer>({});

    useEffect(() => {
        if (isOpen) {
            // GA 埋点
            GAEvents.createMatchResult()
        }
    }, [isOpen]);

    useEffect(() => {
        if (roomResult) {
            if (user?.id === roomResult.ownerUserId) {
                setLeftPlayer({
                    name: roomResult.ownerCgtnName ?? roomResult?.ownerGuestName ?? '-',
                    avatar: roomResult.ownerCgtnAvatar ?? imgUrls.defaultAvatarUrl,
                    steps: roomResult.ownerGuessTimes,
                    time: roomResult.ownerPlayTime,
                    win: roomResult.ownerWin,
                    result: roomResult?.result === 1
                })

                setRightPlayer({
                    name: roomResult.invitedCgtnName ?? roomResult?.invitedGuestName ?? '-',
                    avatar: roomResult.invitedCgtnAvatar ?? imgUrls.defaultAvatarUrl,
                    steps: roomResult.invitedGuessTimes,
                    time: roomResult.invitedPlayTime,
                    win: roomResult.invitedWin,
                    result: roomResult?.result === 2
                })
            } else {
                setRightPlayer({
                    name: roomResult.ownerCgtnName ?? roomResult?.ownerGuestName ?? '-',
                    avatar: roomResult.ownerCgtnAvatar ?? imgUrls.defaultAvatarUrl,
                    steps: roomResult.ownerGuessTimes,
                    time: roomResult.ownerPlayTime,
                    win: roomResult.ownerWin,
                    result: roomResult?.result === 1
                })

                setLeftPlayer({
                    name: roomResult.invitedCgtnName ?? roomResult?.invitedGuestName ?? '-',
                    avatar: roomResult.invitedCgtnAvatar ?? imgUrls.defaultAvatarUrl,
                    steps: roomResult.invitedGuessTimes,
                    time: roomResult.invitedPlayTime,
                    win: roomResult.invitedWin,
                    result: roomResult?.result === 2
                })
            }
        }

    }, [roomResult]);

    // 判断左侧要显示什么文字
    const handleLeftTextTitle = (item?: IVSPlayerRoomInfo): string => {

        if (!item) return ""
        let text = "You "

        if (item.result === 0) {
            text += 'Draw'
            return text;
        }

        if (item.ownerUserId === user?.id) {
            if (item.result === 1) {
                text += 'Win!'
                return text;
            } else if (item.result === 2) {
                text += 'Lose'
                return text;
            }
        }

        if (item.invitedUserId === user?.id) {
            if (item.result === 2) {
                text += 'Win!'
                return text;
            } else if (item.result === 1) {
                text += 'Lose'
                return text;
            }
        }

        return text;
    }

    // 判断右侧要显示什么文字
    const handleRightTextTitle = (item?: IVSPlayerRoomInfo): string => {
        if (!item) return ""

        let text = ""

        if (item.result === null) {
            text += 'Opponent'
            return text;
        }

        if (item.result === 0) {
            text += 'Draw'
            return text;
        }

        if (item.ownerUserId === user?.id) {
            if (item.result === 2) {
                text += 'Win!'
                return text;
            } else if (item.result === 1) {
                text += 'Lose'
                return text;
            }
        }

        if (item.invitedUserId === user?.id) {
            if (item.result === 1) {
                text += 'Win!'
                return text;
            } else if (item.result === 2) {
                text += 'Lose'
                return text;
            }
        }

        return text;
    }


    return (
        <CustomPopup isOpen={isOpen} onClose={onClose}>
            <div
                ref={targetRef} className={`bg-color-white width-300 height-345 border-radius-10 display-fixed-center`}>
                <img className="common-dialog-embellish-bg-left-top" src={imgUrls.leftTopBgDialogUrl}
                     alt="pic"/>
                <img className="common-dialog-embellish-bg-right-bottom" src={imgUrls.rightBottomBgDialogUrl}
                     alt="pic"/>
                {/*关闭按钮*/}
                <img className="exit-close-btn" onClick={onClose}
                     src={imgUrls.closerBtnGreyUrl} alt="pic"/>
                {/*标题*/}
                <div
                    className="my-roboto-bold margin-top-20 font-size-16 text-center">Result
                </div>
                {/*头像*/}
                <div className="margin-top-26 height-68 display-flex-row">
                    <div
                        className="width-166 height-66 common-position-absolute display-flex-row display-flex-align-items-center display-flex-justify-content-center"
                        style={{
                            backgroundImage: `url(${leftPlayer.win ? imgUrls.vsPlayerModalLeftWinBg : imgUrls.vsPlayerModalLeftLoseBg})`,
                            backgroundSize: "100% 100%",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "left"
                        }}>
                        <Avatar className="width-40 height-40"/>
                        <div
                            className="margin-left-8 text-italic margin-right-16 my-roboto-bold font-size-16 color-white">{handleLeftTextTitle(roomResult)}</div>
                    </div>
                    <div
                        className="width-166 margin-left-auto  position-left-auto height-66 bg-img-cover-no-repeat-center common-position-absolute right-0 display-flex-row display-flex-align-items-center display-flex-justify-content-center"
                        style={{
                            backgroundImage: `url(${rightPlayer.win ? imgUrls.challengeFailDialogAvatarRight : imgUrls.vsPlayerModalRightLoseBg})`,
                            backgroundSize: "100% 100%",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "right"
                        }}>
                        <img className="height-40 width-40 margin-left-20"
                             src={rightPlayer?.avatar}
                             alt="pic"/>
                        <div
                            className="margin-left-8 my-roboto-bold text-italic font-size-16 color-white">{handleRightTextTitle(roomResult!)}</div>
                    </div>
                </div>
                {/*对战数据*/}
                <div
                    className="height-118 width-300 margin-top-16 margin-bottom-23 position-relative display-flex-row display-flex-space-between">
                    {/*中间虚线*/}
                    <div className="line-vertical height-124 position-absolute position-top-0 position-left-150"/>
                    <div
                        className="vs-payer-dialog-VS-text my-roboto-bold font-size-17">VS
                    </div>
                    {/*左边*/}
                    <div
                        className="width-150 display-flex-column display-flex-align-items-center display-flex-justify-content-center">
                        <div
                            className="my-roboto-bold font-size-14 ellipsis width-120 text-center color-black-custom">{leftPlayer.name ?? '-'}</div>
                        <div className="font-size-14 margin-top-10 my-roboto-regular color-grey">Attempts</div>
                        <div
                            className="font-size-20 my-roboto-bold color-cyan">{leftPlayer.steps ?? '-'}</div>
                        <div className="font-size-14 margin-top-10 my-roboto-regular color-grey">Time used</div>
                        <div
                            className={`${leftPlayer.win === false ? 'font-size-14' : 'font-size-20'} display-flex-justify-content-center display-flex-align-content height-20 my-roboto-bold color-cyan`}>{leftPlayer.win === false ? "Didn't make it" : (leftPlayer?.time ? formatTime(leftPlayer?.time ?? 0) : '-')}</div>
                    </div>
                    {/*右边*/}
                    <div
                        className="width-150 display-flex-column display-flex-align-items-center display-flex-justify-content-center">
                        <div
                            className="my-roboto-bold ellipsis width-120 font-size-14 text-center color-black-custom">{rightPlayer.name ?? '-'}</div>
                        <div className="font-size-14 margin-top-10 my-roboto-regular color-grey">Attempts</div>
                        <div
                            className="font-size-20 my-roboto-bold color-cyan">{rightPlayer?.steps ?? '-'}</div>
                        <div className="font-size-14 margin-top-10 my-roboto-regular color-grey">Time used</div>
                        <div
                            className={`${rightPlayer.win === false ? 'font-size-14' : 'font-size-20'} height-20 my-roboto-bold color-cyan display-flex-align-content`}>{rightPlayer.win === false ? "Didn't make it" : rightPlayer?.time ? formatTime(rightPlayer?.time ?? 0) : '-'}</div>
                    </div>

                </div>
                {/*按钮部分*/}
                <div onClick={onClose}
                     className="margin-left-right-auto width-273 height-43 border-radius-5 display-flex-column display-flex-justify-content-center display-flex-align-items-center bg-color-liner-green-challenge">
                    <div className="font-size-16 my-roboto-medium color-white">Close</div>
                </div>
            </div>
        </CustomPopup>
    );
}
export default VsPlayerGameEndDialog;